export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 3,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 4,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 10,
    label: 'Email',
    intlKey: 'table.email'
  },
  {
    id: 11,
    label: 'System rights',
    intlKey: 'table.system_rights'
  },
  {
    id: 12,
    label: 'Status',
    intlKey: 'table.status'
  }
]
